import { memo } from 'react';

import { Badge, Text } from '@/components/core';
import { useImageSrc } from '@/hooks';
import { toProfileId, useGetProfile } from '@/hooks/api';
import { DivProps, OmitChildren } from '@/utils';

export type ProfileBadgeProps = OmitChildren<DivProps> & {
  profileId: string;
};

const IProfileBadge = ({ profileId, ...rest }: ProfileBadgeProps) => {
  const { data: profile } = useGetProfile(toProfileId(profileId));
  const { src } = useImageSrc({ source: profile?.pictureUrl });

  if (!profile) return null;

  return (
    <Badge variant="plain" {...rest}>
      <img className="-m-xs mr-xs size-4 rounded-full" src={src} />
      <Text>{profile.givenName}</Text>
    </Badge>
  );
};

export const ProfileBadge = memo(IProfileBadge) as typeof IProfileBadge;
